import { ChangeEvent, useCallback } from 'react';
import { Switch as MuiSwitch, SwitchProps } from '@mui/material';
import { FieldProps } from 'formik';

import { withFormLabel } from './withFormLabel';

type Props = FieldProps & SwitchProps;

export const Switch = withFormLabel(({ field, ...props }: Props): JSX.Element => {
  const checked = field?.value ?? field?.checked ?? props.checked;

  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      if (field?.onChange) field?.onChange(e);
      if (props.onChange) props.onChange(e, checked);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [field?.onChange, props.onChange],
  );

  return <MuiSwitch {...field} {...props} onChange={onChange} checked={checked} />;
});
